module.exports = __webpack_public_path__ + "img/xg1.e1981c65.png";